import React, { useContext, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useHistory } from "react-router";
import { AuthContext } from "../context/AuthContext";
import firebase from "firebase/app";
import getTourById from "../requests/getTourById";
import deleteTour from "../requests/deleteTour";

const ConfirmTourDeletion = () => {
  const history = useHistory();
  const { setUser } = useContext(AuthContext);
  const [ token, setToken ] = useState("");
  const [tour, setTour] = useState({
    name: "",
    artist: ""
  });

  const { tourId } = useParams();

  firebase.auth().onAuthStateChanged(function(firebaseUser) {
    if (firebaseUser) {
      setUser(firebaseUser);
      firebaseUser.getIdToken().then(token => {
        setToken(token);
        // console.log("JWT:", token);
      })
    } else {
      history.push("/login");
    }
  });

  useEffect(() => {
    if (token) {
      getTourById(token, tourId).then(response => {
        console.log(response.data);
        if (response.status === 200) {
          setTour(response.data[0]);
        }
      });
    }
  }, [token, tourId]);

  const handleDeleteTour = (event) => {
    if (token) {
      deleteTour(token, tourId)
        .then((response) => {
          if (response.status === 204) {
            history.push("/")
          }
        });
    }
  };

  if (tour.name) {
    return (
      <div className="container center">
        <div className="confirm-delete">
          <h2 className="heading">Confirm deletion</h2>
          <h3>You have chosen to delete this Tour:</h3>
          <article className="toBeDeleted">
            <p>Tour name: <strong>{tour.name}</strong></p>
            <p>Featuring: <strong>{tour.artist}</strong></p>
          </article>
          <p>Are you sure that you want to delete the Tour?</p>
          <p>Any Gigs, Products and Sales Items created as part of that Tour will also be deleted.</p>
          <p>This cannot be undone.</p>
          <div>
            <p><Link to="/" className="button-link">Take me back to the Tours page</Link></p>
            <button
              type="button"
              className="form-button center"
              onClick={handleDeleteTour}
            >
              Confirm deletion of {tour.name}
            </button>
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <div className="container">
        <div className="unauthorised-deletion">
          <h2 className="heading">Unauthorised</h2>
          <p>You appear not to be authorised to delete this tour.</p>
          <p>If you arrived here by clicking a link on the Tours page then something went wrong between leaving that page and arriving here. Perhaps <Link to="/">go back</Link> and try again.</p>
          <p>If you found your way here by some other means then you're wasting your time.</p>
          
        </div>
      </div>
    )
  }
};

export default ConfirmTourDeletion;
